import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";

export default function UpdatePhieuNhapKho({ item, icons, icon, data: DATA }) {
  const { lang, proxy, functions, auth } = useSelector((state) => state);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const token = localStorage.getItem("_token");
  const [search, setSearch] = useState();
  const [refresh, setRefresh] = useState();
  const [dataViTri, setDataViTri] = useState([]);
  const [dataViTriFilter, setDataViTriFilter] = useState([]);
  const [selected, setSelected] = useState([]);
  const [dataKhoDonVi, setDataKhoDonVi] = useState([]);
  const [valueOption, setValueOption] = useState({});

  const { handleSubmit, control, register, watch, reset } = useForm();

  const formatted = (date) => {
    // return moment(date).format("YYYY-MM-DDTHH:mm:ss");
    if (date && date.length) {
      return date.slice(0, date.length - 2);
    }
  };

  const mapData = (item) => {
    return {
      _id: item?._id,
      maphieunhapkhosaas: item?.maphieunhapkhosaas || "",
      loaigiaodich: valueOption?.[item?._id],
      malenhsanxuat: item?.malenhsanxuat || "",
      makhocon: item?.makhocon || "",
      vitritrongkho: item?.vitritrongkho || "",
      matochuckho: item?.matochuckho || "",
      sanpham: item?.sanpham || "",
      soluongnhapkhothute: item?.soluongnhapkhothute || 0,
      solot: item?.solot || "",
      hansudung: item?.hansudung || "",
      ngaynhap: formatted(item?.ngaynhap) || "",
      nguoitaophieu: item?.nguoitaophieu,
      tenTaiKhoanThietBi: item?.tenTaiKhoanThietBiLogNK || "",
      taiKhoanThietBi: item?.taiKhoanThietBiLogNK || "user1",
    };
  };

  useEffect(() => {
    if (!search) return;

    fetch(proxy() + `/api/SyncERP/search/PhieuNhapKho`, {
      method: "POST",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(search),
    })
      .then((res) => res.json())
      .then((res) => {
        const { result, total } = res;
        if (result.length) {
          const mapped = result.map(mapData);
          setData(mapped);
        }
      })
      .catch((err) => console.error(err));
  }, [search]);

  const watchs = watch();

  useEffect(() => {
    if (data.length) {
      const makhocon = DATA.makhocon || data?.[0]?.makhocon;
      const masanpham = DATA?.MaSP || data?.[0]?.["sanpham"];

      fetch(proxy() + `/api/612A693B37A441ADBF9799C38D2B85B3/${makhocon}`, {
        method: "GET",
        headers: {
          Authorization: token,
          "content-type": "application/json",
        },
        // body: JSON.stringify(search),
      })
        .then((res) => res.json())
        .then((res) => {
          const { data, total } = res;
          const uniqueData = Array.from(
            new Map(
              data
                .filter((item) => item?.KhoDonVi)
                .map((item) => [
                  item.KhoDonVi,
                  { label: item.KhoDonVi, value: item.KhoDonVi, ...item },
                ])
            ).values()
          );
          const uniqueDataViTri = Array.from(
            new Map(
              data
                .filter((item) => item?.MaViTriKhoERP)
                .map((item) => [
                  item.MaViTriKhoERP,
                  {
                    ...item,
                    label: item.MaViTriKhoERP,
                    value: item.MaViTriKhoERP,
                  },
                ])
            ).values()
          );

          setDataViTri(uniqueDataViTri);
          // setDataViTriFilter(uniqueDataViTri);
          setDataKhoDonVi(uniqueData);

          // if (result.length) {
          //   setData(result);
          // }
        })
        .catch((err) => console.error(err));
    }
  }, [data]);

  // useEffect(() => {
  //   if (data.length) {
  //     const makhocon = DATA.makhocon || data?.[0]?.["makhocon"];
  //     const masanpham = DATA?.MaSP || data?.[0]?.["sanpham"];
  //     fetch(proxy() + `/api/SyncERP/Lot?id=${masanpham}&sub=${makhocon}`, {
  //       method: "GET",
  //       headers: {
  //         Authorization: token,
  //         "content-type": "application/json",
  //       },
  //       // body: JSON.stringify(search),
  //     })
  //       .then((res) => res.json())
  //       .then((res) => {
  //         const { data, total } = res;
  //         const uniqueDataViTri = Array.from(
  //           new Map(
  //             data
  //               .filter((item) => item?.mavitrikho)
  //               .map((item) => [
  //                 item.mavitrikho,
  //                 { ...item, label: item.mavitrikho, value: item.mavitrikho },
  //               ])
  //           ).values()
  //         );

  //         setDataViTri(uniqueDataViTri);
  //       })
  //       .catch((err) => console.error(err));
  //   }
  // }, [data]);

  const handleModalShow = () => {
    setShowModal(true);
    setSearch((prev) => ({
      ...prev,
      ["maPhieuNhapKho"]: DATA?.["2SPN"],
    }));
  };
  const handleModalClose = () => setShowModal(false);

  const onSubmit = (d) => {
    const newD = d?.data?.map((item) => ({
      ...item,
      soluongnhapkhothute: isNaN(item?.soluongnhapkhothute)
        ? null
        : item?.soluongnhapkhothute,
    }));
    const mappedData = {
      ...d,
      data: data?.map((item, index) => {
        return {
          ...item,
          ...newD?.[index],
          loaigiaodich: valueOption?.[item?._id] || "WIP Completion",
          ngaynhap: newD?.[index]?.ngaynhap
            ? newD?.[index]?.ngaynhap
            : moment().format("YYYY-MM-DDTHH:mm:ss"),
        };
      }),
      TenTaiKhoanThietBi: data?.[0]?.tenTaiKhoanThietBi,
      TaiKhoanThietBi: data?.[0]?.taiKhoanThietBi,
      MaPhieuNhapKho: DATA?.["2SPN"],
    };

    Swal.fire({
      title: "Đang cập nhật...",
      // text: "Vui lòng chờ trong giây lát.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    fetch(proxy() + `/api/SyncERP/PhieuNhapKho`, {
      method: "POST",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(mappedData),
    })
      .then((res) => res.json())
      .then((res) => {
        const {
          result,
          errorscode,
          success,
          total,
          createdItems,
          description,
          message,
        } = res;
        Swal.close();
        if (success == "True") {
          Swal.fire({
            icon: "success",
            title: "Thành công",
            text: "Cập nhật dữ liệu thành công!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Lỗi",
            text: `ERP phản hồi: ${description || message} `,
          });
        }
      })
      .catch((err) => console.error(err));
    // .finally(() => Swal.close());
  };
  return (
    <div>
      <FontAwesomeIcon
        icon={icons[icon]?.icon}
        title={item?.title ? item?.title : lang["redirect_button"]}
        onClick={handleModalShow}
      />
      <div>
        <Modal
          show={showModal}
          onHide={handleModalClose}
          dialogClassName="modal-80w"
        >
          <Modal.Header>
            <Modal.Title className="w-100">
              {/* Chứng từ KCS */}
              <div
                className="text-center fw-bold"
                style={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                {item?.title ? item?.title : lang["redirect_button"]}
              </div>
            </Modal.Title>
          </Modal.Header>
          <form
            className="container-fluid"
            onSubmit={handleSubmit(onSubmit)}
            style={{
              height: data?.length > 10 && "70vh",
              overflow: data?.length > 10 && "auto",
            }}
          >
            <Modal.Body>
              <div className="row form-row">
                <div className="row col-sm-12 mb-2">
                  <div className="col-sm-2">Số LOT</div>
                  <div className="col-sm-2">Kho Con</div>
                  {/* <div className="col-sm-3">Kho Đơn Vị</div> */}
                  <div className="col-sm-2">Vị Trí</div>
                  <div className="col-sm-2">Tăng/giảm khối lượng tồn</div>
                  <div className="col-sm-2">Số Lượng (Tấn)</div>
                  <div className="col-sm-2">Ngày Nhập</div>
                </div>

                {data && data.length > 0
                  ? data.map((item, index) => (
                      <div className="row col-sm-12 mb-2" key={item?._id}>
                        {/* Số LOT */}
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            value={item?.solot}
                            disabled
                          />
                        </div>

                        {/* Kho Con */}
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            value={item?.makhocon}
                            disabled
                          />
                        </div>

                        {/* Kho Đơn Vị */}
                        {/* <div className="col-sm-3">
                          <Controller
                            control={control}
                            name={`data.${index}.KhoDonVi`}
                            // defaultValue={item?.khodonvi || null}
                            render={({ field }) => {
                              return (
                                <Select
                                  {...field}
                                  options={dataKhoDonVi}
                                  placeholder={lang["select value"]}
                                  value={
                                    selected?.[index]?.KhoDonVi || {
                                      label: item.KhoDonVi,
                                      value: item.KhoDonVi,
                                    }
                                  }
                                  isClearable
                                  onChange={(opt) => {
                                    field.onChange(opt?.value);
                                    const filterViTri = dataViTri.filter(
                                      ({ KhoDonVi }) => KhoDonVi === opt?.value
                                    );
                                    if (!opt) {
                                      setDataViTriFilter(dataViTri);
                                      setSelected([]);
                                    } else {
                                      if (filterViTri.length) {
                                        setDataViTriFilter(filterViTri);
                                      } else {
                                        setDataViTriFilter([]);
                                      }
                                      setSelected((prev) => {
                                        const newPrev = [...prev];
                                        newPrev[index] = {
                                          ...newPrev,
                                          KhoDonVi: opt,
                                        };

                                        return newPrev;
                                      });
                                    }

                                    // setData((prev) => {
                                    //   const updated = [...prev];
                                    //   updated[index] = {
                                    //     ...updated[index],
                                    //     khoDonVi: selected?.value,
                                    //   };
                                    //   return updated;
                                    // });
                                  }}
                                  // value={selected || ""}
                                  noOptionsMessage={() => (
                                    <>{lang["not found data"]}</>
                                  )}
                                />
                              );
                            }}
                          />
                        </div> */}

                        {/* Vị trí trong kho */}
                        <div className="col-sm-2">
                          <Controller
                            control={control}
                            name={`data.${index}.vitritrongkho`}
                            defaultValue={item?.vitritrongkho || null}
                            render={({ field }) => {
                              const options = dataViTriFilter.length
                                ? dataViTriFilter
                                : dataViTri;

                              return (
                                <Select
                                  {...field}
                                  isClearable
                                  options={options}
                                  placeholder={lang["select value"]}
                                  onChange={(opt) => {
                                    setSelected((prev) => {
                                      const newPrev = [...prev];
                                      newPrev[index] = {
                                        ...newPrev[index],
                                        vitritrongkho: opt,
                                      };

                                      return newPrev;
                                    });

                                    setData((prev) => {
                                      const updated = [...prev];
                                      updated[index] = {
                                        ...updated[index],
                                        vitritrongkho: opt?.value,
                                      };
                                      return updated;
                                    });
                                  }}
                                  value={
                                    selected?.[index]?.vitritrongkho || {
                                      label: item.vitritrongkho,
                                      value: item.vitritrongkho,
                                    }
                                  }
                                  noOptionsMessage={() => (
                                    <>{lang["not found data"]}</>
                                  )}
                                  isDisabled={true}
                                />
                              );
                            }}
                          />
                        </div>
                        <div className="col-sm-2">
                          <select
                            class="form-control form-select-lg mb-3"
                            aria-label="Large select example"
                            value={valueOption?.[item?._id]}
                            onChange={(e) => {
                              setValueOption((prev) => {
                                const newPrev = { ...prev };
                                newPrev[item?._id] = e.target.value;
                                return newPrev;
                              });
                            }}
                          >
                            <option value="WIP Completion">Tăng</option>
                            <option value="WIP Completion Return">Giảm</option>
                          </select>
                        </div>

                        {/* Số lượng nhập kho thực tế */}
                        <div className="col-sm-2">
                          <input
                            type="number"
                            className="form-control"
                            min={0}
                            step="any"
                            {...register(`data.${index}.soluongnhapkhothute`, {
                              valueAsNumber: true,
                            })}
                          />
                        </div>

                        <div className="col-sm-2">
                          <input
                            type="datetime-local"
                            className="form-control"
                            {...register(`data.${index}.ngaynhap`)}
                          />
                        </div>
                        {/* Nút xóa */}
                        {/* <div className="col-sm-1">
                          <button
                            type="button"
                            className="btn btn-danger m-0"
                            onClick={() => {
                              setData((prev) =>
                                prev.filter((_, i) => i !== index)
                              );
                            }}
                          >
                            Xóa
                          </button>
                        </div> */}
                      </div>
                    ))
                  : null}

                {/* <div className="col-sm-12 mt-4">
                  <label className="fw-bold">Ghi chú</label>
                  <textarea
                    className="form-control"
                    rows={5}
                    {...register("ghichu")}
                  ></textarea>
                </div> */}
              </div>
            </Modal.Body>
            <Modal.Footer
              style={{
                justifyContent: "center",
              }}
            >
              <Button variant="primary" type="submit">
                Cập Nhật
              </Button>
              <Button
                variant="danger"
                onClick={handleModalClose}
                className="ml-2"
              >
                Hủy
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
}
